
import {
    USERS_DEX_PANEL_LOADING,
    USERS_DEX_PANEL_LOAD,
    USERS_DEX_PANEL_ERROR,
    USERS_DEX_PANEL_RESET,

    USERSINDI_DEX_PANEL_LOADING,
    USERSINDI_DEX_PANEL_LOAD,
    USERSINDI_DEX_PANEL_ERROR,
    USERSINDI_DEX_PANEL_RESET,

    USERDEX_OBS_PANEL_LOADING,
    USERDEX_OBS_PANEL_LOADED,
    USERDEX_OBS_PANEL_ERROR,
    USERDEX_OBS_PANEL_RESET,

    OBSDEX_ACCION_LOADING,
    OBSDEX_ACCION_SUCCESS,
    OBSDEX_ACCION_ERROR,
    OBSDEX_ACCION_RESET
  } from '../../types/dex';

const INITIAL_STATE = {
    loading: false,
    loaded: false,
    error: "",
    data: [],      
    count: 0,     
    currentPage: 1, 
    currentSearch: "",
    currentDexId: null,

        // USUARIO INDIVIDUAL
    usuarioIndividual: [],
    usuarioIndividualLoading: false,
    usuarioIndividualLoaded: false,
    usuarioIndividualError: "",

    userdexObs: [], 
    userdexObsLoading: false, 
    userdexObsError: false, 
    userdexObsLoaded: "",

    obsdexAccionLoading: false,
    obsdexAccionLoaded: false,
    obsdexAccion: null,
    obsdexAccionError: null
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case OBSDEX_ACCION_RESET:
            return {
                ...state,
                obsdexAccionLoading: false,
                obsdexAccionLoaded: false,
                obsdexAccionError: "",
                obsdexAccion: [], 
            };

        case OBSDEX_ACCION_LOADING:
            return {
                ...state,
                obsdexAccionLoading: true,
                obsdexAccionLoaded: false,
                obsdexAccionError: "",
                obsdexAccion: [], 
            };

        case OBSDEX_ACCION_SUCCESS:
            return {
                ...state,
                obsdexAccionLoading: false,
                obsdexAccionLoaded: true,
                obsdexAccion: action.payload, 
                obsdexAccionError: "",
            };

        case OBSDEX_ACCION_ERROR:
            return {
                ...state,
                obsdexAccionLoading: false,
                obsdexAccionLoaded: false,
                obsdexAccion: [],
                obsdexAccionError: action.payload,
            };

        case USERDEX_OBS_PANEL_RESET:
            return {
                ...state,
                userdexObs: null,
                userdexObsLoaded: false,
                userdexObsError: null,
                userdexObsLoading: false,
            };

        case USERDEX_OBS_PANEL_LOADING:
            return {
                ...state,
                userdexObsLoading: true,
                userdexObsLoaded: false,
                userdexObsError: "",
                userdexObs: [], 
            };

        case USERDEX_OBS_PANEL_LOADED:
            return {
                ...state,
                userdexObsLoading: false,
                userdexObsLoaded: true,
                userdexObs: action.payload, 
                userdexObsError: "",
            };

        case USERDEX_OBS_PANEL_ERROR:
            return {
                ...state,
                userdexObsLoading: false,
                userdexObsLoaded: false,
                userdexObs: [],
                userdexObsError: action.payload,
            };

        case USERSINDI_DEX_PANEL_LOADING:
            return {
                ...state,
                usuarioIndividualLoading: true,
                usuarioIndividualLoaded: false,
                usuarioIndividualError: "",
                usuarioIndividual: [],
            };

        case USERSINDI_DEX_PANEL_LOAD:
            return {
                ...state,
                usuarioIndividualLoading: false,
                usuarioIndividualLoaded: true,
                usuarioIndividual: action.payload, 
                usuarioIndividualError: "",
            };

        case USERSINDI_DEX_PANEL_ERROR:
            return {
                ...state,
                usuarioIndividualLoading: false,
                usuarioIndividualLoaded: false,
                usuarioIndividual: [],
                usuarioIndividualError: action.payload,
            };

        case USERSINDI_DEX_PANEL_RESET:
            return {
                ...state,
                usuarioIndividualLoading: false,
                usuarioIndividualLoaded: false,
                usuarioIndividualError: "",
                usuarioIndividual: null,
            };
        
        case USERS_DEX_PANEL_LOADING:
            return {
                ...state,
                loading: true,
                loaded: false,
                data: [], 
                error: "",
            };

        case USERS_DEX_PANEL_LOAD:
            return {
                ...state,
                loading: false,
                loaded: true,
                data: action.payload.results,
                count: action.payload.count,
                currentPage: action.payload.page,
                currentSearch: action.payload.search,
                currentDexId: action.payload.dexId,
                error: "",
            };

        case USERS_DEX_PANEL_ERROR:
            return {
                ...state,
                loading: false,
                loaded: false,
                data: [],
                error: action.payload,
            };

        case USERS_DEX_PANEL_RESET:
            return INITIAL_STATE;

        default:
            return state;
    }
}